export const sortByDescendingCount = (a: { count: number }, b: { count: number }) => {
  return b.count - a.count
}
